// @flow

import navigator from 'utils/navigator';

export const isOpera = () => typeof window.opr !== 'undefined';
export const isMSEdgeLegacy = () => navigator.userAgent.indexOf('Edge') > -1;
export const isIE11 = () => !!window.MSInputMethodContext && !!document.documentMode;
export const isIOSChrome = () => Boolean(navigator.userAgent.match('CriOS'));
export const isIEMobile = () => navigator.userAgent.indexOf('IEMobile') > -1;
export const isMobileIOS = () => {
  // Check for iOS devices including iPad, iPhone, and iPod
  const iosDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];

  // Check if the platform is iOS
  if (typeof window !== 'undefined') {
    return (
      iosDevices.includes(window.navigator.platform) || iosDevices.includes(navigator.platform)
    )
      // iPad on iOS 13+ detection
      || (window.navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  }

  return false;
};

// https://stackoverflow.com/a/13348618/2877719
export const isChrome = () => {
  const isChromium = window.chrome;

  return isIOSChrome() || (
    isChromium !== null
    && typeof isChromium !== 'undefined'
    && navigator.vendor === 'Google Inc.'
    && isOpera() === false
    && isMSEdgeLegacy() === false
  );
};

export const isFirefox = () => navigator.userAgent.indexOf('Firefox') > -1;

export const isMobileBrowser = () => typeof window.orientation !== 'undefined' || isIEMobile();
export const isRecordingSupported = () => !isMobileBrowser() && (isChrome() || isFirefox());

/**
 * Checks if device has "fine pointer control" (i.e., a mouse or stylus) and can hover over
 * elements. It also checks if window.matchMedia is a function before calling it.
 * @returns {boolean}
 * - `true`: if the device doesn't have fine pointer controls or if window.matchMedia isn't
 * a function.
 * - `false`: if the device has fine pointer controls and window.matchMedia is a function.
 */ export const isDeviceWithoutHover = () => typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && !window.matchMedia('(hover: hover) and (pointer: fine)').matches;

/**
 * Detects the current device type based on screen size and user agent
 * @returns {'mobile' | 'tablet' | 'desktop'} The detected device type
 */
export const getDeviceType = () => {
  // First check if it's a mobile device using existing check
  const isMobile = isMobileBrowser();

  // Use matchMedia to check for tablet-sized screens
  // Common tablet breakpoints are between 600px and 1024px
  const isTablet = typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(min-width: 640px) and (max-width: 1024px)').matches;

  // Check user agent for common tablet identifiers
  const userAgent = navigator.userAgent.toLowerCase();
  const isTabletDevice = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

  if (isTabletDevice || isTablet) {
    return 'tablet';
  }

  if (isMobile) {
    return 'mobile';
  }

  return 'desktop';
};
